export var name = 'betslip';
